import request from "../../../../helper/request";

const tierApi = {
  getTiers: () => {
    return request.get("/admin/tiers");
  },

  getTier: (id) => {
    return request.get(`/admin/tiers/${id}`);
  },

  createTier: (tierData) => {
    return request.post("/admin/tiers", tierData);
  },

  updateTier: (id, tierData) => {
    return request.patch(`/admin/tiers/${id}`, tierData);
  },

  deleteTier: (id) => {
    return request.delete(`/admin/tiers/${id}`);
  }
};

export default tierApi;
